<template lang="html">
  <div v-click-outside="closeDropdown" class="dropdown-wrapper">
    <div
      :class="{ disabled: disabled }"
      @click="openDropdown"
      class="header-wrapper"
    >
      <span class="hover" :class="{ floated: selected }">
        {{ defaultText }}
      </span>
      <span class="value" :class="{ selected }">
        <slot name="selected-value">
          {{ getSelected }}
        </slot>
        <!-- <img src="@/assets/icons/closeBadge.png" alt="remove img"> -->
      </span>
      <img
        :class="{ open: open }"
        src="@/assets/icons/dropdownArrowBig.png"
        alt="dropdown arrow icon"
      />
    </div>
    <div v-if="open" class="dropdown">
      <div v-if="list && list.length > 0" class="option-wrapper">
        <input
          id="dropdown-search"
          v-model="search"
          type="text"
          :placeholder="$t('nav.search')"
        />
        <div v-if="removable && selected" @click="remove" class="option">
          {{ $t("main.clear") }}
        </div>
        <template v-if="schools">
          <div
            :class="{ active: item === selected }"
            @click="setOption(item)"
            v-for="(item, index) in list"
            :key="index"
            class="school-option"
            :title="`${item.sch_name}, ${item.sch_address}, ${item.sch_region}`"
          >
            <div class="name">{{ item.sch_name }}</div>
            <div class="location">
              {{ item.sch_address + ", " + item.sch_region }}
            </div>
          </div>
        </template>
        <template v-else-if="customSeach">
          <div
            :class="{ active: item === selected }"
            @click="setOption(item)"
            v-for="(item, index) in list"
            :key="index"
            class="option"
            :title="
              typeof item === 'object' && item !== null ? item.label : item
            "
          >
            {{ typeof item === "object" && item !== null ? item.label : item }}
          </div>
        </template>
        <template v-else>
          <div
            :class="{ active: item === selected }"
            @click="setOption(item)"
            v-for="(item, index) in filteredList"
            :key="index"
            class="option"
            :title="
              typeof item === 'object' && item !== null ? item.label : item
            "
          >
            <slot name="dropdown-option" :item="item">
              {{
                typeof item === "object" && item !== null ? item.label : item
              }}
            </slot>
          </div>
        </template>
      </div>
      <div v-else class="option-wrapper">
        <input
          id="dropdown-search"
          v-model="search"
          type="text"
          :placeholder="$t('nav.search')"
        />
        <div class="option">
          {{ $t("main.noOptions") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  props: {
    list: {
      type: Array,
      required: false
    },
    selected: {
      required: false
    },
    defaultText: {
      type: String,
      required: false
    },
    removable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    customSeach: {
      type: Boolean,
      default: false
    },
    schools: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false,
      search: null
    };
  },
  methods: {
    remove(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit("remove");
      this.closeDropdown();
    },
    closeDropdown() {
      this.open = false;
      this.search = null;
    },
    openDropdown() {
      if (this.disabled) {
        return;
      }
      this.open = !this.open;
      setTimeout(() => {
        document.querySelector("#dropdown-search").focus();
      }, 100);
    },
    setOption(option) {
      this.$emit("changeOption", option);
      this.closeDropdown();
    },
    typing(e) {
      console.log(e);
    }
  },
  computed: {
    getSelected() {
      return typeof this.selected === "object" && this.selected !== null
        ? this.selected.label
        : this.selected;
    },
    filteredList() {
      if (this.list === undefined || this.list === null) {
        return [];
      }
      if (typeof this.list[0] === "string") {
        if (this.search) {
          return this.list.filter(item => {
            return this.search
              .toLowerCase()
              .split(" ")
              .every(v => item.toLowerCase().includes(v));
          });
        } else {
          return this.list;
        }
      }
      if (this.search) {
        return this.list.filter(item => {
          return this.search
            .toLowerCase()
            .split(" ")
            .every(v => item.label.toLowerCase().includes(v));
        });
      } else {
        return this.list;
      }
    }
  },
  watch: {
    search: function(val) {
      this.$emit("search", val);
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown-wrapper {
  position: relative;
  background: white;
  display: flex;
  flex-direction: column;
  min-width: 200px;

  .header-wrapper {
    height: 50px;
    box-sizing: border-box;
    border: 1px solid $gray-blue-700;
    border-radius: 8px;
    // width: max-content;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    min-width: fit-content;

    cursor: pointer;

    span {
      letter-spacing: 0%;
    }
    .hover {
      position: absolute;
      left: 12px;
      top: 14px;
      transition: 0.2s ease all;
      padding: 0;
      pointer-events: none;
      font-size: 16px;
      color: $blue-300;
    }
    .floated {
      top: 1px;
      padding-top: 2px;
      font-size: 12px;
      background-color: transparent;
      pointer-events: none;

      // top: 1;
      // color: #3b82f6;
    }
    .value {
      color: $blue-1000;
      transform: translateY(6px);
    }

    img {
      transition-duration: 0.3s;
    }
    img.open {
      transform: rotate(180deg);
    }
  }
  .header-wrapper.disabled {
    cursor: not-allowed;
    // opacity: 0.5;
    background-color: $gray-blue-600;
  }
  .dropdown {
    position: absolute;
    top: calc(100% + 3px);
    background-color: white !important;
    left: 1px;
    min-width: calc(100% - 2px);
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.06);
    z-index: 1;

    .option-wrapper {
      position: relative;
      max-height: 200px;
      max-width: 400px;
      overflow-x: hidden;
      // max-width: 80%;
      overflow: auto;
      @import "@/assets/scss/scrollbarStyles.scss";
      @include scrollbar;
      @import "@/assets/scss/cardStyles.scss";

      .school-option {
        height: 55px;
        line-height: 18px;
        max-width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        cursor: pointer;
        padding-left: 10px;
        padding-right: 10px;

        .name,
        .location {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: 100%;
        }
      }
      .school-option.active {
        background: rgba(196, 196, 196, 0.15);
      }

      .option {
        white-space: nowrap;
        height: 38px;
        line-height: 38px;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 100%;
        display: block;
        justify-content: flex-start;
        align-items: center;
        text-align: left;
        padding-left: 10px;
        padding-right: 10px;
        cursor: pointer;
        box-sizing: border-box;
      }
      .option.active {
        background: rgba(196, 196, 196, 0.15);
        // opacity: 0.07;
      }
      input {
        border: none;
        width: 100%;
        padding: 0px;
        padding-left: 10px;
        box-sizing: border-box;
        height: 38px;
      }
      input:focus {
        outline: none;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .dropdown-wrapper {
    font-size: 0.9em;
    .dropdown {
      position: absolute;
      top: calc(100% + 3px);
      background-color: white !important;
      left: 1px;
      //min-width: calc( 100% - 2px );
      min-width: 50%;
      width: 100%;
      box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.06);
      z-index: 1;

      .option-wrapper {
        position: relative;
        max-height: 200px;
        max-width: 100%;
        overflow: auto;
        @import "@/assets/scss/scrollbarStyles.scss";
        @include scrollbar;
        @import "@/assets/scss/cardStyles.scss";

        .option {
          white-space: wrap;
          min-height: 38px;
          max-width: 100%;
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 10px;
          padding-right: 10px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
